// Libs
import React, { useContext, useEffect, useRef, useState } from 'react';
// Services
import { ApiServiceV2 } from 'services';
// Context
import { ModalBuilderContext } from 'core/context';
// Components
import { Wrapper, Modal, LogoIcon } from 'components';
// ResumePaymentComponents
import { HeaderSettings, ResumeBody } from './Components';
// Actions
import { sendToast } from 'screens/Dashboard/actions';

const ResumePayment = () => {
	const { payload: modalPayload, cleanModal } = useContext(ModalBuilderContext);
	const { paymentId, refreshMainData, isInvoice = false } = modalPayload;

	const [mainState, _setMainState] = useState({
		isLoading: false,
		isRefreshResumen: false,
		modeviewGroupOrders: true,

		paycutId: undefined,

		paycut: {},
		payment: {},
		resumenPayment: {},
	});

	const setMainState = newState =>
		_setMainState(current => ({ ...current, ...newState }));

	const handdleCatchError = err => {
		sendToast({ message: err.message, type: err.type });
		setMainState({ isRefreshResumen: false });
		cleanModal();
	};

	const getPaycut = () => {
		ApiServiceV2.post({
			url: `/paycuts/getPaycuts`,
			data: {
				type: isInvoice ? 'invoice' : 'payment',
				paycutId: mainState.paycutId,
				last_row_id: 0,
				limit: 1,
			},
		})
			.then(paycuts => {
				setMainState({ paycut: paycuts[0] || {}, isRefreshResumen: false });
			})
			.catch(handdleCatchError);
	};

	const getPaymentDetails = async () => {
		setMainState({ isLoading: true });

		return ApiServiceV2.get({
			url: `/payments/${paymentId}`,
		})
			.then(({ payment }) => {
				setMainState({
					payment,
					paycutId: payment.paycut_id,
					isLoading: false,
				});
			})
			.catch(handdleCatchError);
	};

	const getResumePayments = () => {
		setMainState({ isRefreshResumen: true });

		ApiServiceV2.post({
			url: `/payments/resume`,
			data: { payIds: [paymentId] },
		})
			.then(resumenPayment => {
				setMainState({ resumenPayment, isRefreshResumen: false });
			})
			.catch(handdleCatchError);
	};

	useEffect(() => {
		getPaymentDetails();
		getResumePayments();
	}, []);

	useEffect(() => {
		if (mainState.paycutId) getPaycut();
	}, [mainState.paycutId]);

	return (
		<Modal
			title={null}
			closable={false}
			centered={false}
			visible={true}
			onCancel={cleanModal}
			footer={null}
		>
			<Wrapper
				highBackground
				width='100%'
				padding='10px'
				margin='0'
				flexDirection='column'
				alignItems='center'
				justifyContent='flex-start'
			>
				{mainState.isLoading ? (
					<LogoIcon spin />
				) : (
					<>
						<HeaderSettings
							title='Resumen'
							paymentId={paymentId}
							isPdfGenered={mainState.payment.pdf_generated}
							paymentState={mainState.payment.state}
							setMainState={setMainState}
							getResumePayments={getResumePayments}
							isRefreshResumen={mainState.isRefreshResumen}
						/>
						<ResumeBody
							payment={mainState.payment}
							paymentOrders={mainState.resumenPayment.orders}
							paymentLines={mainState.resumenPayment.lines}
							coinId={mainState.paycut.coin_id}
							cleanModal={cleanModal}
							modeviewGroupOrders={mainState.modeviewGroupOrders}
							refreshMainData={refreshMainData}
						/>
					</>
				)}
			</Wrapper>
		</Modal>
	);
};

export default ResumePayment;
